import { Routes } from 'routes';

export const DEFAULT_OPTIONS = {
  dropdown: [
    { title: 'Home Contents', url: Routes.HOME_CONTENTS_INSURANCE, migrated: true },
    { title: 'Building', url: Routes.BUILDING_INSURANCE, migrated: true },
    {
      title: 'Single Items',
      url: Routes.SINGLE_ITEMS_INSURANCE,
      migrated: true,
      comingSoon: false,
    },
  ],
  hiddenItems: [
    { title: 'Naked Difference', url: Routes.Difference, migrated: true },
    { title: 'Team Naked', url: Routes.CAREERS_AT_NAKED, migrated: true },
    { title: 'FAQs', url: Routes.FAQ, migrated: true },
  ],
  social: [
    {
      icon: 'facebook',
      url: Config.Shared.Links.SocialMedia.FACEBOOK_URL,
      label: 'Facebook link',
    },
    {
      icon: 'instagram',
      url: Config.Shared.Links.SocialMedia.INSTAGRAM_URL,
      label: 'Instagram link',
    },
    {
      icon: 'twitter',
      url: Config.Shared.Links.SocialMedia.TWITTER_URL,
      label: 'Twitter link',
    },
    {
      icon: 'linkedin',
      url: Config.Shared.Links.SocialMedia.LINKEDIN_URL,
      label: 'LinkedIn link',
    },
    {
      icon: 'tiktok',
      url: Config.Shared.Links.SocialMedia.TIKTOK_URL,
      label: 'TikTok link',
    },
  ],
};
